import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

import {
	check_two_bend_bay,
	Render_measurtement,
	Toggle_measurtement_type,
	Render_summary,
	Render_status,
	Render_save_overlay,
} from "../js/bay-checker.js";

export default function One_bend() {
	const [update, force_update] = useState(0);

	const [measurtement_ab, set_measurtement_ab] = useState("");
	const [measurtement_bc, set_measurtement_bc] = useState("");
	const [measurtement_cd, set_measurtement_cd] = useState("");

	const [measurtement_ac, set_measurtement_ac] = useState("");
	const [measurtement_ad, set_measurtement_ad] = useState("");
	const [measurtement_bd, set_measurtement_bd] = useState("");

	const [measurtement_1a, set_measurtement_1a] = useState("");
	const [measurtement_d2, set_measurtement_d2] = useState("");

	// console.log(measurtement_ab);

	let does_it_work = check_two_bend_bay(
		measurtement_cd,
		measurtement_ab,
		measurtement_bc,
		measurtement_ac,
		measurtement_ad,
		measurtement_bd
	);
	let the_summary = "(empty)";

	useEffect(() => {
		let svg_wrap = document.querySelector(".svg_wrap");
		//console.log("height: ", svg_wrap.classHeight);
	});

	return (
		<div className="bay max_width">
			<div className="top">
				<div className="header">
					<NavLink className="back_to_home" to="/app/bay-checker/"></NavLink>
					<h2>
						<strong>Two bend</strong> bay
					</h2>
				</div>

				<div className="svg_wrap">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 330 150">
						<path
							fill="#7BAABD"
							fillRule="evenodd"
							d="M86.2 24.7A4 4 0 0 1 90 22h150a4 4 0 0 1 3.8 2.7l29 87.3H326a4 4 0 0 1 0 8h-56a4 4 0 0 1-3.8-2.7l-29-87.3H92.8l-29.1 87.3A4 4 0 0 1 60 120H4a4 4 0 0 1 0-8h53.1l29.1-87.3Z"
							clipRule="evenodd"
						/>
						<path
							fill="#D4D0C4"
							d="M96.7 31.7a1.5 1.5 0 1 0-1.4 2.6l2.9 1.5a1.5 1.5 0 0 0 1.3-2.7l-2.8-1.4Zm138 2.6a1.5 1.5 0 0 0-1.4-2.6l-2.8 1.4a1.5 1.5 0 0 0 1.3 2.7l2.9-1.5ZM105.3 36a1.5 1.5 0 0 0-1.3 2.7l5.7 2.8a1.5 1.5 0 0 0 1.3-2.7l-5.7-2.8ZM226 38.7a1.5 1.5 0 0 0-1.3-2.7l-5.7 2.8a1.5 1.5 0 0 0 1.3 2.7l5.7-2.8Zm-109.2 3a1.5 1.5 0 0 0-1.3 2.7l5.7 2.9a1.5 1.5 0 0 0 1.3-2.7l-5.7-2.9Zm97.7 2.7a1.5 1.5 0 0 0-1.3-2.7l-5.7 2.9a1.5 1.5 0 0 0 1.3 2.7l5.7-2.9ZM203 50.2a1.5 1.5 0 0 0-1.3-2.7l-5.7 2.8a1.5 1.5 0 0 0 1.3 2.7l5.7-2.8Zm-74.7-2.7a1.5 1.5 0 0 0-1.3 2.7l5.7 2.8a1.5 1.5 0 0 0 1.3-2.7l-5.7-2.8Zm11.5 5.7a1.5 1.5 0 0 0-1.3 2.7l5.7 2.9a1.5 1.5 0 0 0 1.3-2.7l-5.7-2.9Zm51.7 2.7a1.5 1.5 0 0 0-1.3-2.7l-5.7 2.9a1.5 1.5 0 0 0 1.3 2.7l5.7-2.9ZM151.3 59a1.5 1.5 0 0 0-1.3 2.7l5.7 2.8a1.5 1.5 0 0 0 1.3-2.7l-5.7-2.8Zm28.7 2.7a1.5 1.5 0 0 0-1.3-2.7l-5.7 2.8a1.5 1.5 0 0 0 1.3 2.7l5.7-2.8Zm-17.2 3a1.5 1.5 0 0 0-1.3 2.7l.1.1a1.5 1.5 0 0 0 1.4 2.7l2-1 2 1a1.5 1.5 0 0 0 1.4-2.7l.1-.1a1.5 1.5 0 0 0-1.3-2.7l-2.2 1.1-2.2-1Zm10.8 5.4a1.5 1.5 0 1 0-1.4 2.7l5.3 2.6a1.5 1.5 0 1 0 1.4-2.6l-5.3-2.7Zm-15.8 2.7a1.5 1.5 0 0 0-1.4-2.7l-5.3 2.7a1.5 1.5 0 1 0 1.4 2.6l5.3-2.6Zm26.3 2.6a1.5 1.5 0 1 0-1.3 2.7l5.3 2.6a1.5 1.5 0 0 0 1.3-2.7l-5.3-2.6ZM147.2 78a1.5 1.5 0 1 0-1.3-2.6l-5.3 2.6a1.5 1.5 0 0 0 1.3 2.7l5.3-2.6Zm47.5 2.7a1.5 1.5 0 0 0-1.3 2.7l5.2 2.6a1.5 1.5 0 1 0 1.4-2.7l-5.3-2.6Zm-58.1 2.7a1.5 1.5 0 0 0-1.3-2.7l-5.3 2.6a1.5 1.5 0 1 0 1.4 2.7l5.2-2.6Zm68.7 2.6a1.5 1.5 0 1 0-1.4 2.6l5.3 2.7a1.5 1.5 0 0 0 1.3-2.7l-5.2-2.6ZM126 88.6a1.5 1.5 0 1 0-1.3-2.6l-5.2 2.6a1.5 1.5 0 0 0 1.3 2.7l5.3-2.7Zm89.8 2.6a1.5 1.5 0 0 0-1.3 2.7l5.2 2.6a1.5 1.5 0 1 0 1.4-2.6l-5.3-2.7ZM115.5 94a1.5 1.5 0 0 0-1.3-2.8l-5.3 2.7a1.5 1.5 0 1 0 1.4 2.6l5.2-2.6Zm110.9 2.5a1.5 1.5 0 1 0-1.4 2.7l5.3 2.6a1.5 1.5 0 0 0 1.3-2.7l-5.2-2.6ZM105 99.2a1.5 1.5 0 1 0-1.4-2.7l-5.2 2.6a1.5 1.5 0 0 0 1.3 2.7l5.3-2.6Zm-10.6 5.3a1.5 1.5 0 0 0-1.3-2.7l-5.3 2.6a1.5 1.5 0 0 0 1.3 2.7l5.3-2.6Zm142.6-2.7a1.5 1.5 0 0 0-1.4 2.7l5.3 2.6a1.5 1.5 0 0 0 1.3-2.7l-5.3-2.6Zm-153.1 7.9a1.5 1.5 0 1 0-1.4-2.6l-5.3 2.6a1.5 1.5 0 0 0 1.4 2.7l5.3-2.7Zm163.6-2.7a1.5 1.5 0 0 0-1.4 2.7l5.3 2.7a1.5 1.5 0 1 0 1.4-2.7l-5.3-2.6Zm10.5 5.3a1.5 1.5 0 0 0-1.3 2.7l2.6 1.3a1.5 1.5 0 0 0 1.4-2.6l-2.7-1.4ZM73.3 115a1.5 1.5 0 1 0-1.3-2.7l-2.7 1.4a1.5 1.5 0 0 0 1.4 2.6l2.6-1.3Zm16.7 3.5a1.5 1.5 0 0 0 0 3h2.9a1.5 1.5 0 0 0 0-3H90Zm8.7 0a1.5 1.5 0 0 0 0 3h5.7a1.5 1.5 0 1 0 0-3h-5.7Zm11.5 0a1.5 1.5 0 0 0 0 3h5.8a1.5 1.5 0 0 0 0-3h-5.8Zm11.5 0a1.5 1.5 0 1 0 0 3h5.8a1.5 1.5 0 0 0 0-3h-5.8Zm11.6 0a1.5 1.5 0 0 0 0 3h5.7a1.5 1.5 0 1 0 0-3h-5.7Zm11.5 0a1.5 1.5 0 1 0 0 3h5.8a1.5 1.5 0 0 0 0-3h-5.8Zm11.5 0a1.5 1.5 0 0 0 0 3h5.8a1.5 1.5 0 1 0 0-3h-5.8Zm11.6 0a1.5 1.5 0 1 0 0 3h5.8a1.5 1.5 0 0 0 0-3h-5.8Zm11.5 0a1.5 1.5 0 0 0 0 3h5.8a1.5 1.5 0 1 0 0-3h-5.8Zm11.6 0a1.5 1.5 0 1 0 0 3h5.7a1.5 1.5 0 0 0 0-3H191Zm11.5 0a1.5 1.5 0 0 0 0 3h5.8a1.5 1.5 0 1 0 0-3h-5.8Zm11.5 0a1.5 1.5 0 0 0 0 3h5.8a1.5 1.5 0 0 0 0-3H214Zm11.6 0a1.5 1.5 0 0 0 0 3h5.7a1.5 1.5 0 1 0 0-3h-5.7Zm11.5 0a1.5 1.5 0 0 0 0 3h2.9a1.5 1.5 0 0 0 0-3h-2.9Z"
						/>
						<g className="g_2">
							<path className="shape" d="M330 134a14 14 0 1 1-14-14h14v14Zm-3 0a11 11 0 1 1-11-11h11v11Z" />
							<path d="m312.2 137.5-.1 1.5h8.7v-2.2h-5.5a3 3 0 0 1 1-1l.8-.5a33.9 33.9 0 0 1 1.9-1l.8-.7.5-.9c.2-.3.3-.7.3-1.1a3 3 0 0 0-1.8-2.7 6.3 6.3 0 0 0-3.6-.2 6.8 6.8 0 0 0-3 1.6l1.5 1.7.5-.5.6-.4c.2-.2.4-.3.7-.3l.8-.2.9.2.6.5.2.7-.2.6-.6.5-1 .5a93 93 0 0 0-2.7 1.7l-.8 1-.5 1.2Z" />
						</g>
						<g className="g_d">
							<path
								className="shape"
								d="M242 134a14 14 0 0 1 14-14h14v14a14 14 0 1 1-28 0Zm3 0c0-6 5-11 11-11h11v11a11 11 0 0 1-22 0Z"
							/>
							<path d="M251.4 127.2V140h4.6c1.3 0 2.4-.3 3.4-.8s1.6-1.3 2.2-2.2c.5-1 .7-2.1.7-3.4 0-1.2-.2-2.3-.7-3.2-.4-1-1.1-1.8-2-2.3-1-.6-2.2-.9-3.6-.9h-4.6Zm8 4.2c.3.6.4 1.4.4 2.2 0 .8-.1 1.5-.4 2.2-.3.6-.7 1.1-1.3 1.5-.6.3-1.3.5-2 .5h-2.2v-8.4h2.1a4 4 0 0 1 2 .5c.6.4 1 .9 1.4 1.5Z" />
						</g>
						<g className="g_c">
							<path className="shape" d="M240 16a14 14 0 1 1 14 14h-14V16Zm3 0a11 11 0 1 1 11 11h-11V16Z" />
							<path d="M248.3 13.2a6.5 6.5 0 0 0 0 4.7c.3.8.8 1.5 1.3 2.1a5.6 5.6 0 0 0 4.5 2 6.8 6.8 0 0 0 4-1.2c.6-.5 1-1 1.2-1.7l-2-1.1a3.4 3.4 0 0 1-2 1.7l-1.1.2a3.4 3.4 0 0 1-2.8-1.3 4.7 4.7 0 0 1-1-3c0-.5 0-1 .2-1.5l.7-1.4a4 4 0 0 1 1.2-1c.4-.2 1-.4 1.6-.4l1.2.2c.4.1.8.3 1.1.6.4.3.6.7.8 1.2l2-1.4a5 5 0 0 0-2-2c-.8-.5-1.8-.8-3-.8a6.1 6.1 0 0 0-5.9 4.1Z" />
						</g>
						<g className="g_b">
							<path className="shape" d="M76 30a14 14 0 1 1 14-14v14H76Zm0-3a11 11 0 1 1 11-11v11H76Z" />
							<path d="M80.5 20.5a3 3 0 0 0 .5-1.8c0-.8-.2-1.5-.6-2a4 4 0 0 0-1.8-1.3c.6-.2 1-.6 1.4-1.2a3.5 3.5 0 0 0-.9-4.5c-.4-.3-1-.5-1.5-.5h-6.9V22H77c.7 0 1.4-.1 2-.4.7-.2 1.2-.6 1.6-1Zm-2.2-3.1a1.8 1.8 0 0 1 0 1.7l-.6.6-.8.2h-3.7v-3.4H77c.3 0 .6.1.8.3.2.1.4.3.5.6Zm-5.1-2.8v-3.3h3.4l.7.2.5.6c.2.2.2.5.2.8 0 .4 0 .7-.2 1a1.4 1.4 0 0 1-1.3.7h-3.3Z" />
						</g>
						<g className="g_a">
							<path
								className="shape"
								d="M88 134a14 14 0 1 1-28 0v-14h14a14 14 0 0 1 14 14Zm-3 0a11 11 0 0 1-22 0v-11h11c6 0 11 5 11 11Z"
							/>
							<path d="M74.8 127.2h-2.5L67.5 140h2.6l1.2-3.2h4.4L77 140h2.6l-4.7-12.8Zm-1.3 2.6 1.8 5.3h-3.6l1.8-5.3Z" />
						</g>
						<g className="g_1">
							<path className="shape" d="M14 120a14 14 0 1 1-14 14v-14h14Zm0 3a11 11 0 1 1-11 11v-11h11Z" />
							<path d="M17.5 139v-2.2h-2.3v-8h-2.4l-.5.4-.8.5-.9.5a2 2 0 0 1-.8.2v2.3l.8-.1a6.3 6.3 0 0 0 1.7-.8l.5-.4v5.4h-2.6v2.2h7.3Z" />
						</g>
					</svg>
				</div>

				<Toggle_measurtement_type force_update={force_update} />
			</div>

			<div className="pusher" style={{ aspectRatio: "33 / 15" }}></div>

			<div className={does_it_work ? "the_measurements pass" : "the_measurements"}>
				<h3>
					<strong>Wall</strong> measurements
				</h3>

				<div className="measurtement_wrapper">
					{["ab", "bc", "cd"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<h3>
					<strong>Cross</strong> Measurements
				</h3>

				<div className="measurtement_wrapper">
					{["ac", "ad", "bd"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<h3>
					Optional <strong>Distances</strong>
				</h3>

				<div className="measurtement_wrapper">
					{["1a", "d2"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<Render_status does_it_work={does_it_work} />

				{["ab", "bc", "cd", "ac", "ad", "bd", "1a", "d2"].map((key) => {
					let new_line = Render_summary({
						the_key: key,
						measurtement_mm: parseInt(eval("measurtement_" + key)),
					});
					if (the_summary == "(empty)") the_summary = new_line;
					else the_summary += new_line;
				})}

				<Render_save_overlay force_update={force_update} the_summary={the_summary} bay_type="Two Bend" />
			</div>
		</div>
	);
}
